import React from 'react'
import { useParams } from 'react-router-dom'

import { getViewer } from '../features/viewers/registry'

const ViewerPage: React.FC = () => {
  const { viewerId = '', variantId = '' } = useParams<{ viewerId: string; variantId: string }>()

  const entry = getViewer(viewerId)

  if (!entry) {
    return (
      <section className="space-y-2">
        <h1 className="text-xl font-semibold">Unknown viewer</h1>
        <p className="text-sm text-gray-600">
          No viewer is registered under <code className="rounded bg-gray-100 px-1.5 py-0.5">{viewerId}</code>.
        </p>
      </section>
    )
  }

  const ViewerComponent = entry.component
  return <ViewerComponent variantId={variantId} />
}

export default ViewerPage
